export enum FilterSource {
  LIVECHAT = 'livechat',
  POST_STATISTICS = 'post_statistics',
  POST_TARGETING = 'post_targeting',
  TRIGGER_RULE = 'trigger_rule',
  TRIGGER_RULE_USER_FIELD = 'trigger_rule_user_field',
  AUDIENCE = 'audience',
  FLOWBUILDER_MULTICONDITION = 'flowbuilder_multicondition',
  AUTOASSIGNMENT_SETTINGS = 'autoassignment_settings',
}

export enum FilterScenario {
  CONDITION_NODE = 'condition_node',
  LIVECHAT = 'livechat',
  AUTO_ASSIGN = 'auto_assign',
  IMPORT_CONTACTS = 'import_contacts',
  EXTERNAL_REQUESTS = 'external_requests',
  GOOGLE_SHEETS = 'google_sheets',
  CONTACTS = 'contacts',
}

export enum ConditionValueOperator {
  IS = 'IS',
  IS_NOT = 'IS_NOT',
}
